import { Injectable, Inject } from '@angular/core';
import * as Immutable from "immutable";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Unsubscribe } from "redux";
import { AritcoRequest } from '../models';
import { ConfDataRequest, ApiResponse } from "../../shared/models";
import { ApiResponseBuilder } from "../providers/apiResponseBuilder";
import { HttpService } from '../../../shared/providers';
import { BaseController } from '../providers/baseController';

@Injectable({
  providedIn: 'root',
}) 
export class AritcoController extends BaseController {
  public getControllerUrl(): string {
    throw new Error('Method not implemented.');
  }

  public url = 'api/aritco';

  constructor(
    @Inject(HttpService) public httpService: HttpService,
    public apiResponseBuilder: ApiResponseBuilder
  ) { super(httpService, apiResponseBuilder)}

  public get(aritcoRequest: AritcoRequest): Observable<ApiResponse> {
    return this.httpService.get(this.url, aritcoRequest).pipe(this.buildResponseObject);
  }

  public buildResponseObject = map((response, index) => this.apiResponseBuilder.build(response));
}
